/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Privacy_Fairusefactors_Limited2Inputs */

const id_privacy_fairusefactors_limited2 = /** @type {(inputs: Privacy_Fairusefactors_Limited2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Penggunaan Terbatas:`)
};

const ms_privacy_fairusefactors_limited2 = /** @type {(inputs: Privacy_Fairusefactors_Limited2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Penggunaan Terhad:`)
};

const da_privacy_fairusefactors_limited2 = /** @type {(inputs: Privacy_Fairusefactors_Limited2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Begrænset Brug:`)
};

const de_privacy_fairusefactors_limited2 = /** @type {(inputs: Privacy_Fairusefactors_Limited2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Begrenzte Nutzung:`)
};

const en_us2_privacy_fairusefactors_limited2 = /** @type {(inputs: Privacy_Fairusefactors_Limited2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Limited Use:`)
};

const es_es2_privacy_fairusefactors_limited2 = /** @type {(inputs: Privacy_Fairusefactors_Limited2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uso limitado:`)
};

const es_mx2_privacy_fairusefactors_limited2 = /** @type {(inputs: Privacy_Fairusefactors_Limited2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uso limitado:`)
};

const fil_privacy_fairusefactors_limited2 = /** @type {(inputs: Privacy_Fairusefactors_Limited2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Limitadong Paggamit:`)
};

const fr_privacy_fairusefactors_limited2 = /** @type {(inputs: Privacy_Fairusefactors_Limited2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Utilisation limitée :`)
};

const it_privacy_fairusefactors_limited2 = /** @type {(inputs: Privacy_Fairusefactors_Limited2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uso limitato:`)
};

const hu_privacy_fairusefactors_limited2 = /** @type {(inputs: Privacy_Fairusefactors_Limited2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Korlátozott felhasználás:`)
};

const nl_privacy_fairusefactors_limited2 = /** @type {(inputs: Privacy_Fairusefactors_Limited2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Beperkt gebruik:`)
};

const no_privacy_fairusefactors_limited2 = /** @type {(inputs: Privacy_Fairusefactors_Limited2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Begrenset bruk:`)
};

const pl_privacy_fairusefactors_limited2 = /** @type {(inputs: Privacy_Fairusefactors_Limited2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ograniczone użycie:`)
};

const pt_br2_privacy_fairusefactors_limited2 = /** @type {(inputs: Privacy_Fairusefactors_Limited2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uso limitado:`)
};

const pt_privacy_fairusefactors_limited2 = /** @type {(inputs: Privacy_Fairusefactors_Limited2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uso limitado:`)
};

const ro_privacy_fairusefactors_limited2 = /** @type {(inputs: Privacy_Fairusefactors_Limited2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Utilizare limitată:`)
};

const fi_privacy_fairusefactors_limited2 = /** @type {(inputs: Privacy_Fairusefactors_Limited2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rajoitettu käyttö:`)
};

const sv_privacy_fairusefactors_limited2 = /** @type {(inputs: Privacy_Fairusefactors_Limited2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Begränsad användning:`)
};

const vi_privacy_fairusefactors_limited2 = /** @type {(inputs: Privacy_Fairusefactors_Limited2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sử dụng hạn chế:`)
};

const tr_privacy_fairusefactors_limited2 = /** @type {(inputs: Privacy_Fairusefactors_Limited2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sınırlı Kullanım:`)
};

const cs_privacy_fairusefactors_limited2 = /** @type {(inputs: Privacy_Fairusefactors_Limited2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Omezené použití:`)
};

const bg_privacy_fairusefactors_limited2 = /** @type {(inputs: Privacy_Fairusefactors_Limited2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ограничена употреба:`)
};

const ru_privacy_fairusefactors_limited2 = /** @type {(inputs: Privacy_Fairusefactors_Limited2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ограниченное использование:`)
};

const uk_privacy_fairusefactors_limited2 = /** @type {(inputs: Privacy_Fairusefactors_Limited2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Обмежене використання:`)
};

const ar_privacy_fairusefactors_limited2 = /** @type {(inputs: Privacy_Fairusefactors_Limited2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`استخدام محدود:`)
};

const hi_privacy_fairusefactors_limited2 = /** @type {(inputs: Privacy_Fairusefactors_Limited2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`सीमित उपयोग:`)
};

const th_privacy_fairusefactors_limited2 = /** @type {(inputs: Privacy_Fairusefactors_Limited2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`การใช้งานอย่างจำกัด:`)
};

const ja_privacy_fairusefactors_limited2 = /** @type {(inputs: Privacy_Fairusefactors_Limited2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`限定的な使用：`)
};

const zh_cn2_privacy_fairusefactors_limited2 = /** @type {(inputs: Privacy_Fairusefactors_Limited2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`有限使用：`)
};

const zh_hant1_privacy_fairusefactors_limited2 = /** @type {(inputs: Privacy_Fairusefactors_Limited2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`有限使用：`)
};

const ko_privacy_fairusefactors_limited2 = /** @type {(inputs: Privacy_Fairusefactors_Limited2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`제한된 사용:`)
};

/**
* | output |
* | --- |
* | "Limited Use:" |
*
* @param {Privacy_Fairusefactors_Limited2Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const privacy_fairusefactors_limited2 = /** @type {((inputs?: Privacy_Fairusefactors_Limited2Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Privacy_Fairusefactors_Limited2Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_privacy_fairusefactors_limited2(inputs)
	if (locale === "ms") return ms_privacy_fairusefactors_limited2(inputs)
	if (locale === "da") return da_privacy_fairusefactors_limited2(inputs)
	if (locale === "de") return de_privacy_fairusefactors_limited2(inputs)
	if (locale === "en-US") return en_us2_privacy_fairusefactors_limited2(inputs)
	if (locale === "es-ES") return es_es2_privacy_fairusefactors_limited2(inputs)
	if (locale === "es-MX") return es_mx2_privacy_fairusefactors_limited2(inputs)
	if (locale === "fil") return fil_privacy_fairusefactors_limited2(inputs)
	if (locale === "fr") return fr_privacy_fairusefactors_limited2(inputs)
	if (locale === "it") return it_privacy_fairusefactors_limited2(inputs)
	if (locale === "hu") return hu_privacy_fairusefactors_limited2(inputs)
	if (locale === "nl") return nl_privacy_fairusefactors_limited2(inputs)
	if (locale === "no") return no_privacy_fairusefactors_limited2(inputs)
	if (locale === "pl") return pl_privacy_fairusefactors_limited2(inputs)
	if (locale === "pt-BR") return pt_br2_privacy_fairusefactors_limited2(inputs)
	if (locale === "pt") return pt_privacy_fairusefactors_limited2(inputs)
	if (locale === "ro") return ro_privacy_fairusefactors_limited2(inputs)
	if (locale === "fi") return fi_privacy_fairusefactors_limited2(inputs)
	if (locale === "sv") return sv_privacy_fairusefactors_limited2(inputs)
	if (locale === "vi") return vi_privacy_fairusefactors_limited2(inputs)
	if (locale === "tr") return tr_privacy_fairusefactors_limited2(inputs)
	if (locale === "cs") return cs_privacy_fairusefactors_limited2(inputs)
	if (locale === "bg") return bg_privacy_fairusefactors_limited2(inputs)
	if (locale === "ru") return ru_privacy_fairusefactors_limited2(inputs)
	if (locale === "uk") return uk_privacy_fairusefactors_limited2(inputs)
	if (locale === "ar") return ar_privacy_fairusefactors_limited2(inputs)
	if (locale === "hi") return hi_privacy_fairusefactors_limited2(inputs)
	if (locale === "th") return th_privacy_fairusefactors_limited2(inputs)
	if (locale === "ja") return ja_privacy_fairusefactors_limited2(inputs)
	if (locale === "zh-CN") return zh_cn2_privacy_fairusefactors_limited2(inputs)
	if (locale === "zh-Hant") return zh_hant1_privacy_fairusefactors_limited2(inputs)
	return ko_privacy_fairusefactors_limited2(inputs)
});
export { privacy_fairusefactors_limited2 as "privacy.fairUseFactors.limited" }